import { useCallback } from "react";
import type { VehicleType } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchVehicleType = (
    vehicleTypeId?: string | null,
): UseFetchActionReturn<VehicleType | undefined> => {
    const fetchVehicleType: () => Promise<VehicleType | undefined> = useCallback(() => {
        if (vehicleTypeId) {
            return store.vehicleTypesApi.vehicleTypesReadVehicleType({ id: vehicleTypeId });
        } else {
            return Promise.resolve(undefined);
        }
    }, [vehicleTypeId]);
    return useFetchAction(fetchVehicleType);
};
